import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SharedModule } from '../../shared/shared.module';
import { ImgSliderComponent } from './components/img-slider/img-slider.component';
import { SocialShareModule } from '../social-share/social-share.module';
import { KettoAssuredModule } from '../ketto-assured/ketto-assured.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SwiperModule,
    SocialShareModule,
    KettoAssuredModule,
    MatButtonModule,
    MatIconModule
  ],
  declarations: [ImgSliderComponent],
  exports: [ImgSliderComponent],
})
export class ImgSliderModule { }
